import { createContext, useContext, useState, useCallback } from 'react';

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, type = 'info', duration = 3000) => {
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev.slice(-2), { id, message, type, duration }]);
    if (duration > 0) {
      setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), duration);
    }
    return id;
  }, []);

  const dismiss = useCallback((id) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  }, []);

  return (
    <ToastContext.Provider value={{ showToast, dismiss, toasts }}>
      {children}
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  return {
    showSuccess: (msg, dur = 3000) => ctx.showToast(msg, 'success', dur),
    showError:   (msg, dur = 0)    => ctx.showToast(msg, 'error', dur),
    showInfo:    (msg, dur = 3000) => ctx.showToast(msg, 'info', dur),
    showToast:   ctx.showToast,
    dismiss:     ctx.dismiss,
    toasts:      ctx.toasts,
  };
}
